import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the BusinessUserOrderListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-business-user-order-list',
  templateUrl: 'business-user-order-list.html',
})
export class BusinessUserOrderListPage {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad BusinessUserOrderListPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/business-user-order-list/business-user-order-list.ts